import React, { useState, useEffect, useRef } from 'react';
import { Tooltip, IconButton } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useStyles } from './styles';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import FavoriteIcon from '@mui/icons-material/Favorite';
import { setFavorites } from '../../redux/slices/podcastsSlice';
import { getPodcastIdFromUrl } from '../../utils/updatePodcastUrl';

export const FavoriteButton = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    currentPodcast,
    favorites,
    demoModePodcasts,
    topPodcasts: { loading },
    activePlatform,
  } = useSelector((state) => state.podcasts);

  const [platformSwitchTime, setPlatformSwitchTime] = useState(null);
  const [isFavorite, setIsFavorite] = useState(false);
  const prevPlatformRef = useRef(activePlatform);

  const podId = getPodcastIdFromUrl();
  const isDemoMode = demoModePodcasts.length > 0;
  const currentPodcastId = isDemoMode ? currentPodcast?.collectionId : podId;

  const isRecentPlatformSwitch = platformSwitchTime && Date.now() - platformSwitchTime < 1500;
  const isDisabled = loading || isRecentPlatformSwitch;

  useEffect(() => {
    if (prevPlatformRef.current !== activePlatform) {
      setPlatformSwitchTime(Date.now());
      prevPlatformRef.current = activePlatform;
    }
  }, [activePlatform]);

  useEffect(() => {
    if (!currentPodcastId) {
      setIsFavorite(false);
      return;
    }

    const favoriteStatus = favorites.some((fav) => String(fav.podcastId) === String(currentPodcastId));
    setIsFavorite(favoriteStatus);
  }, [currentPodcastId, favorites]);

  const handleClick = () => {
    if (isDisabled) {
      return;
    }

    dispatch(
      setFavorites({
        podcastId: currentPodcastId,
        name: currentPodcast.collectionName,
      })
    );
  };

  const buttonContent = (
    <IconButton onClick={handleClick} className={classes.favoriteButton} disabled={isDisabled}>
      {isFavorite ? (
        <FavoriteIcon className={classes.favoriteIcon} />
      ) : (
        <FavoriteBorderIcon className={classes.favoriteIcon} />
      )}
    </IconButton>
  );

  return isDisabled ? (
    buttonContent
  ) : (
    <Tooltip title={isFavorite ? 'Remove from favorites' : 'Add to favorites'} placement="top" arrow>
      {buttonContent}
    </Tooltip>
  );
};
